import {
  type InventorizationTechnicalDetails,
  isRemoteReadingMountType,
} from '@/features/inventorization/domain/inventorization-technical';
import { type LocalPhotoRef, PHOTO_CONTEXTS } from '@/shared/capture/capture-session';

export interface InventorizationSyncPhotoRef {
  capturedAt: string;
  context: LocalPhotoRef['context'];
  id: string;
  localBlobId: string;
  qualityStatus?: NonNullable<LocalPhotoRef['quality']>['status'];
  registerId?: string;
  sha256?: string;
  sizeBytes: number;
  thumbnailBlobId?: string;
  uploadedRemoteId?: string;
}

export function getInventorizationSyncPhotos(photos: LocalPhotoRef[], technical: InventorizationTechnicalDetails) {
  const filteredPhotos = isRemoteReadingMountType(technical.mountType)
    ? photos
    : photos.filter(photo => photo.context !== PHOTO_CONTEXTS.module);

  return filteredPhotos.map(toSyncPhotoRef);
}

function toSyncPhotoRef(photo: LocalPhotoRef): InventorizationSyncPhotoRef {
  return {
    capturedAt: photo.capturedAt,
    context: photo.context,
    id: photo.id,
    localBlobId: photo.localBlobId,
    qualityStatus: photo.quality?.status,
    registerId: photo.registerId,
    sha256: photo.sha256,
    sizeBytes: photo.sizeBytes,
    thumbnailBlobId: photo.thumbnailBlobId,
    uploadedRemoteId: photo.uploadedRemoteId,
  };
}
